import { generatePath } from 'react-router-dom';

import { PaymentIntent } from 'types';

import { URL } from '../constants';
import { apiInstance } from '../instance';

import { GetPaymentStatus } from './types';

export const getPaymentStatus = ({ intentId, signal }: GetPaymentStatus) =>
  apiInstance.get<PaymentIntent>(
    generatePath(URL.CLOVER_PAYMENT_STATUS, { intentId: String(intentId) }),
    { timeout: 12_000, signal }
  );
